import { ApiErrorResponse, ApiSuccessResponse } from '../../../../shared/types/api.types'
import { SliceActions } from '../../../../shared/types/slice.types'
import { getItemRequestTrackingDetailsActions } from './getItemRequestTrackingDetails.slice'

export interface GetItemRequestTrackingDetailsRequest {
  itemRequestId: string
}

export interface GetItemRequestTrackingDetailsRequestPayload {
  request: GetItemRequestTrackingDetailsRequest
  onSuccess?: () => void
}

export interface GetItemRequestTrackingDetailsSuccessResponse
  extends ApiSuccessResponse<GetItemRequestTrackingDetailsData> {}

export interface GetItemRequestTrackingDetailsErrorResponse extends ApiErrorResponse {}

export interface LockerOrderDetails {
  orderStatus: string
  dropoffCode?: string // Only for travelers
  dropoffCodeMasked?: string // Only for travelers
  pickupCode?: string // Only for shoppers
  pickupCodeMasked?: string // Only for shoppers
  lockerBank: {
    id: string
    name: string
    address: string
    cityName: string
    countryName: string
    locationNotes: string | null
  }
  doorAssignments: Array<{
    cabinetId: string
    doorId: string
    lockerNumber?: number | null // Number on the locker bank, null when the door is not in the lookup table
    sizeId: string
  }>
  creationTs: string
}

export interface GetItemRequestTrackingDetailsData {
  itemRequestId: number
  externalTrackingNumber: string
  trackingDetails: TrackingDetails
  lockerOrderDetails?: LockerOrderDetails | null
}
export enum TrackingDetailsKeys {
  AcceptedByTraveler = 'acceptedByTraveler',
  PurchasedByTraveler = 'purchasedByTraveler',
  PurchasedByAdmin = 'purchasedByAdmin',
  PurchasedByAgentAdmin = 'purchasedByAgentAdmin',
  InTransitToTraveler = 'inTransitToTraveler',
  DeliveredToTravelerAddress = 'deliveredToTravelerAddress',
  ConfirmedDeliveredToTravelerAddressByAdmin = 'confirmedDeliveredToTravelerAddressByAdmin',
  ConfirmedDeliveredToTravelerAddressByAgentAdmin = 'confirmedDeliveredToTravelerAddressByAgentAdmin',
  ConfirmedReceivedByTraveler = 'confirmedReceivedByTraveler',
  ReadyForDropoffAtLocker = 'readyForDropoffAtLocker',
  AwaitingShopperPickupFromLocker = 'awaitingShopperPickupFromLocker',
  ConfirmedInDestinationCountry = 'confirmedInDestinationCountry',
  ConfirmedDeliveredToShopperByTraveler = 'confirmedDeliveredToShopperByTraveler',
  ConfirmedDeliveredToShopperByShopper = 'confirmedDeliveredToShopperByShopper',
  ConfirmedDeliveredToShopperViaLocker = 'confirmedDeliveredToShopperViaLocker',
  ConfirmedDeliveredToShopperByAdmin = 'confirmedDeliveredToShopperByAdmin',
  ConfirmedDeliveredToShopperByAgentAdmin = 'confirmedDeliveredToShopperByAgentAdmin',
  Lost = 'lost',
  OutOfStock = 'outOfStock'
}

export interface TrackingDetails {
  acceptedByTraveler: TrackingStatus
  purchasedByTraveler: TrackingStatus
  purchasedByAdmin: TrackingStatus
  purchasedByAgentAdmin: TrackingStatus
  inTransitToTraveler: TrackingStatus
  deliveredToTravelerAddress: TrackingStatus
  confirmedDeliveredToTravelerAddressByAdmin: TrackingStatus
  confirmedDeliveredToTravelerAddressByAgentAdmin: TrackingStatus
  confirmedReceivedByTraveler: TrackingStatus
  readyForDropoffAtLocker: TrackingStatus
  awaitingShopperPickupFromLocker: TrackingStatus
  confirmedInDestinationCountry: TrackingStatus
  confirmedDeliveredToShopperByTraveler: TrackingStatus
  confirmedDeliveredToShopperByShopper: TrackingStatus
  confirmedDeliveredToShopperViaLocker: TrackingStatus
  confirmedDeliveredToShopperByAdmin: TrackingStatus
  confirmedDeliveredToShopperByAgentAdmin: TrackingStatus
  lost: TrackingStatus
  outOfStock: TrackingStatus
}

export interface TrackingStatus {
  status: boolean
  timestamp: string
}

export interface GetItemRequestTrackingDetailsState {
  loading: boolean
  error: GetItemRequestTrackingDetailsErrorResponse | null
  success: GetItemRequestTrackingDetailsSuccessResponse | null
}

export type GetItemRequestTrackingDetailsActionTypes = SliceActions<typeof getItemRequestTrackingDetailsActions>
